export function getJointHeirarchy(robot) {

    let jointMap = new Map()

    let traverseChildren = (node, depth, parent) => {
        node.children.forEach(child => {
            if(child.type == "URDFJoint") {
                if(child._jointType != "fixed") {
                    let node = {
                        depth: depth,
                        parent: parent,
                        joint: child
                    }
                    jointMap.set(child.name, node)
                    traverseChildren(child, depth + 1, child)
                }
                else {
                    traverseChildren(child, depth, parent)
                }
            }
            else {
                traverseChildren(child, depth, parent)
            }
        })
    }

    traverseChildren(robot, 0, null)

    let heirarchy = jointMap.entries()
    console.log("joint heirarchy:", heirarchy)
    return jointMap
}